import { CheckCircle2, XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export interface DuplicateReviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pending: boolean;
  onDuplicate: () => void;
  onNotDuplicate: () => void;
}

export function DuplicateReviewDialog(props: DuplicateReviewDialogProps): JSX.Element {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Duplicate review</DialogTitle>
          <DialogDescription>
            Decide whether this order is a duplicate or should continue through the pipeline.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="ghost"
            onClick={() => props.onOpenChange(false)}
            disabled={props.pending}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={props.onDuplicate}
            disabled={props.pending}
          >
            <XCircle className="h-4 w-4" />
            Duplicate
          </Button>
          <Button onClick={props.onNotDuplicate} disabled={props.pending}>
            <CheckCircle2 className="h-4 w-4" />
            Not Duplicated
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
